import { defineComponent as _defineComponent } from 'vue'
import ChangeStoreSideMenuContents from './ChangeStoreSideMenuContents.vue';
import SideMenu from 'Src/js/components/SideMenu.vue';
import { ChangeStoreVariant, StoreChangedEvent } from './change-store-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeStoreSideMenu',
  props: {
    show: { type: Boolean },
    variant: null,
    currentZip: null,
    blainNumber: null,
    desiredQty: null,
    marketRequirement: null
  },
  emits: ["close", "store-changed"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'close'): void;
	(event: 'store-changed', e: StoreChangedEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	show: boolean,
	variant?: ChangeStoreVariant,
	currentZip?: string,
	blainNumber?: string,
	desiredQty?: number,
	marketRequirement?: string,
}

//Imports




function handleStoreChanged(e: StoreChangedEvent) {
	emit('store-changed', e);
}


return { __sfc: true,props, emit, handleStoreChanged, ChangeStoreSideMenuContents, SideMenu }
}

})